import { render, staticRenderFns } from "./HowToDownloadData.vue?vue&type=template&id=268d8d6a&"
import script from "./HowToDownloadData.vue?vue&type=script&lang=js&"
export * from "./HowToDownloadData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports